import axios from "axios";

//use the above function as a template to create yours for CV Search. Have to format qData as a json object
export function getCvSearchResults(qData, getState) {
  const state = getState();
  const jwtToken = state.authData[0].signInUserSession.accessToken.jwtToken;

  const headers = {
    Authorization: `Bearer ${jwtToken}`,
  };

  return axios
    .put(
      `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_ENV}/cv/search`,
      qData,
      { headers }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
}

export function buyCV(qData, getState) {
  const state = getState();
  const jwtToken = state.authData[0].signInUserSession.accessToken.jwtToken;

  const headers = {
    Authorization: `Bearer ${jwtToken}`,
  };

  return axios
    .put(
      `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_ENV}/cv/buy`,
      qData,
      { headers }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (err.response.status === 404) {
        return err.response.status;
      } else {
        throw err
      }
    })

}

export function getSelectedCv(qData, getState) {
  const state = getState();
  const jwtToken = state.authData[0].signInUserSession.accessToken.jwtToken;

  const headers = {
    Authorization: `Bearer ${jwtToken}`,
  };

  const apiUrl = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_ENV}/cv/retrieve/${qData.userId}`;
  return axios
    .get(apiUrl, {
      headers: headers,
    })
    .then((res) => res.data)
    .catch((err) => {
      if (err.response) {
        console.error("Error response from server:", err.response.data);
        console.error("Status code:", err.response.status);
        console.error("Headers:", err.response.headers);
      } else if (err.request) {
        console.error("No response received:", err.request);
      } else {
        console.error("Error setting up request:", err.message);
      }

      console.error("Error getting distribution rule logs:", err);

      throw err;
    });
}
